import React, { useState, useRef } from 'react';
import JoditEditor from 'jodit-react';
import { Tabs, Tab } from '../../../../../components/tabs';
import Container from '../../../../../../../app/components/container';
import ColorPicker from '../../../../../components/colorPicker';
import DesignToggle from '../../../../../components/designToggle';
import Range from '../../../../../../../app/components/range';
import Subtitle from '../../../../../../../app/components/subtitle';
import { FlatButton } from '../../../../../../../app/components/buttons';
import './styles.css';
// props.match.params.appname

const PgmolNewsletter = props => {
  const { onChange, onDesignChange, editorContent, component, design } = props;

  const editor = useRef(null);

  const config = {
    readonly: false, // all options from https://xdsoft.net/jodit/docs/,
    placeholder: 'Start typings...',
    uploader: {
      insertImageAsBase64URI: true,
    },
    controls: {
      classSpan: {
        list: {
          'pgmol-margin-top': 'Margin Top',
          'pgmol-margin-bottom': 'Margin Bottom',
        },
      },
    },
  };

  const updateTextEditorChange = newContent => {
    onChange('editorContent', newContent);
  };

  const handleColorChange = prop => value => {
    const rgba = `rgba(${value.rgb.r},${value.rgb.g},${value.rgb.b},${value.rgb.a})`;
    onDesignChange(prop, rgba);
  };

  return (
    <Tabs>
      <Tab label="content">
        <Container className="pgmol-newsletter-container">
          <JoditEditor
            ref={editor}
            value={editorContent}
            config={config}
            tabIndex={1}
            onBlur={newContent => updateTextEditorChange(newContent)}
          />
          <FlatButton
            label="Save Changes"
            disabled={false}
            primary
            // onClick={saveCaptionHandler}
          />
        </Container>
      </Tab>
      <Tab label="design">
        <Container>
          <DesignToggle
            component={component}
            onDesignChange={(el, isToggled) => onDesignChange(el, isToggled)}
          />
          <ColorPicker
            label="Background Color"
            color={design.backgroundColor}
            height={22}
            disabled={!component.design.enabled}
            onChange={handleColorChange('backgroundColor')}
          />
          <ColorPicker
            label="Border Color"
            color={design.borderColor}
            height={22}
            disabled={!component.design.enabled}
            onChange={handleColorChange('borderColor')}
          />
          <Subtitle className={!component.design.enabled}>
            Border Width
          </Subtitle>
          <Range
            min={0}
            max={100}
            step={1}
            label={
              !design.borderWidth || design.borderWidth === 0
                ? '0px'
                : `${design.borderWidth}px`
            }
            value={design.borderWidth}
            onChange={(el, val) => onDesignChange('borderWidth', val)}
            disabled={!component.design.enabled}
            width="320px"
          />

          <Subtitle className={!component.design.enabled}>
            Border Radius
          </Subtitle>
          <Range
            min={0}
            max={100}
            step={1}
            label={
              !design.borderRadius || design.borderRadius === 0
                ? '0px'
                : `${design.borderRadius}px`
            }
            value={design.borderRadius}
            onChange={(el, val) => onDesignChange('borderRadius', val)}
            disabled={!component.design.enabled}
            width="320px"
          />

          <Subtitle className={!component.design.enabled}>Margin Top</Subtitle>
          <Range
            min={0}
            max={100}
            step={1}
            label={
              !design.marginTop || design.marginTop === 0
                ? '0px'
                : `${design.marginTop}px`
            }
            value={design.marginTop}
            onChange={(el, val) => onDesignChange('marginTop', val)}
            disabled={!component.design.enabled}
            width="320px"
          />

          <Subtitle className={!component.design.enabled}>
            Margin Bottom
          </Subtitle>
          <Range
            min={0}
            max={100}
            step={1}
            label={
              !design.marginBottom || design.marginBottom === 0
                ? '0px'
                : `${design.marginBottom}px`
            }
            value={design.marginBottom}
            onChange={(el, val) => onDesignChange('marginBottom', val)}
            disabled={!component.design.enabled}
            width="320px"
          />

         
        </Container>
      </Tab>
      <Tab
        label="layout"
        disabled
        style={{
          color: '#d9d9d9',
        }}
      />
    </Tabs>
  );
};

export default PgmolNewsletter;
